import { analytics } from './analytics';

export const trackOnRudderStack = async (eventName, payload = {}) => analytics.track(
    eventName,
    payload,
    {
        plugins: {
            all: false,
            'rudder-stack': true,
        },
    },
);
